export default "__VITE_ASSET__DfDysTQa__"